module.exports = __webpack_public_path__ + "static/email-7caaec78add0e75b17e9a9724ddb3955.gif";